/* import __COLOCATED_TEMPLATE__ from './sh-cool-loader.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { htmlSafe } from '@ember/template';
import { task, timeout } from 'ember-concurrency';
import clsx from 'clsx';

/** @module */
class ShCoolLoader extends Component {
  @tracked isAnimating = false;

  get loaderType() {
    return this.args.loaderType || 'circle';
  }

  get isCircleLoader() {
    return this.loaderType === 'circle';
  }

  get isImageLoader() {
    return this.loaderType === 'image';
  }

  get classNames() {
    return clsx(
      this.args.class,
      'sh-cool-loader',
      this.isImageLoader && 'isImageLoader',
      this.isCircleLoader && 'isCircleLoader',
      this.args.maskDisabled && 'mask-disabled',
      this.isAnimating && 'animation-active',
      this.args.isSmall && 'isSmall',
    );
  }

  get circleStyles() {
    const { circleSize, circleColor, circleMargin } = this.args;

    const styles = [ ];
    if (circleSize) styles.push(`width:${circleSize}`, `height:${circleSize}`);
    if (circleColor) styles.push(`background-color:${circleColor}`);
    if (circleMargin) styles.push(`margin:${circleMargin}`);

    return styles.length ? htmlSafe(styles.join(';')) : undefined;
  }

  @task
  *animate() {
    while (true) {
      this.isAnimating = true;
      yield timeout(3220);
      this.isAnimating = false;
      yield timeout(780);
    }
  }
}

export default ShCoolLoader;
